import React from "react";
import "./Finalize.css";
import {
  AGENT_INFO_V01,
  APP_SECTION,
  BENEFICIARY,
  BENEFICIARY_TYPE,
  ENTITY_TYPE,
  nameOfBene,
  PAGES, PARTY, typeForParty
} from "../../../scripts/constants";
import Resources from "../../../Resources/Resources";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {isValid, mygaSession} from "../../../scripts/myga-session";
import {Col, Container, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  isUsingQualifiedFunds,
  willStopPayments,
  isCD,
  isReplacementOrCD,
  isReplacement,
  isRecommendation,
  hasJointOwner,
  hasJointAnnuitant,
  reconcilePaymentsForProducts
} from "../../../scripts/validation";
import {saveApplication} from "../../../scripts/sync-manager";
import {MM_PRODUCT, MM_PRODUCT_DTO} from "../../../scripts/myga-model";
import ProductCardSimpleAnnuity from "../ProductStore/ProductCardSimpleAnnuity";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import PopoverTooltip from "../../../components/PopoverTooltip";
import {productForDTO} from "../../../scripts/product-manager";

const RowCol = props => (
  <Row className={props.className}>
    <Col>
      {props.children}
    </Col>
  </Row>
)

class Finalize extends React.Component {
  constructor(props) {
    super(props);
    
    const initState = {
      cart: mygaSession.getCurrentAppProductDTOs().map(dto=>productForDTO(dto)),
      errorMessage: ''
    };
    
    // if (isRMD()) {
    //   const submission = mygaSession.getCurrentAppSubmission();
    //   const rmd = submission[APP_SUBMISSION.hasTakenRMDForCY];
    //   initState.submission = {
    //     [`${APP_SUBMISSION.hasTakenRMDForCY}_YES`] : (!rmd||rmd==='')?'':rmd==='Yes'?'Yes':'No',
    //     [`${APP_SUBMISSION.hasTakenRMDForCY}_NO`] : (!rmd||rmd==='')?'':rmd==='Yes'?'No':'Yes',
    //   };
    // }

    this.agentInfo = mygaSession.getAgentInfo();
    this.state = initState;
  }

  saveApplication = async () => {
    // NassauLog("Finalize.saveApplication");
    // 2022.05.24.ADivelbiss reconcile the payment options
    const nextProductDTOs = reconcilePaymentsForProducts();
    if (nextProductDTOs) {
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs);
      await saveApplication(APP_SECTION.products)
    }
    
    // if (isRMD()) {
    //   const submission = {...mygaSession.getCurrentAppSubmission()};
    //   if (this.state.submission[`${APP_SUBMISSION.hasTakenRMDForCY}_YES`]==='Yes') {
    //     submission[APP_SUBMISSION.hasTakenRMDForCY] = 'Yes';
    //   }
    //   else if(this.state.submission[`${APP_SUBMISSION.hasTakenRMDForCY}_NO`]==='Yes') {
    //     submission[APP_SUBMISSION.hasTakenRMDForCY] = 'No';
    //   }
    //   NassauLog(`isRMD submission: ${JSON.stringify(this.state.submission,null,2)}`)
    //   mygaSession.setCurrentAppSectionData(APP_SECTION.submission, submission);
    // }
  };
  
  handleChange = (section) => (field) => (e) => {
    let data = this.state[section];
    data[field] = e.target && e.target.value !== undefined ? e.target.value : e;
    let nextState = {errorMessage:''};
    nextState[section] = data;
    this.setState(nextState);
  };
  
  validate = () => {
    if (!!this.pageForm && !this.pageForm.checkValidity()) {
      // NassauLog('form validation');
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finalize_ErrorMissingInformation
      });
      return false;
    }
    
    return true;
  };
  
  onBackPressed = async () => {
    await this.saveApplication()
  };

  onNextPressed = async () => {
    await this.saveApplication()
  };
  
  shouldHidePayments = () => isReplacementOrCD();
  
  hasMultipleProducts = () => this.state.cart.length > 0;

  toProperCase = (val) => {
    return val.charAt(0).toUpperCase() + val.slice(1);
  };

  editButtonForPage = (page,onClick=()=>{}) => {
    return (
      <button type="button"
              className="btn btn-link btn-lg pb-0 pt-0"
              onClick={() => {
                onClick();
                // 2021.08.10.ADivelbiss - new argument specifies the "return to" page.
                this.props.updatePage(page, PAGES.pageAppFinalize);
                // 2021.08.10.ADivelbiss - Handled by the PageManager
                // mygaSession.setReturnToPage(PAGES.pageAppFinalize);
                // this.props.updatePage(page)
              }}>
        <FontAwesomeIcon className={'edit-pencil-icon'} icon={Resources.Icons.Pencil}/>
      </button>
    )
  };

  renderSectionHeader = (title, editBtn) => (
    <Row className={'pb-0'}>
      <Col className={'pb-0'}>
        <b>{title}</b>
        {editBtn}
      </Col>
    </Row>
  )

  renderReadyToSubmit = () => {

    const getReadyText = () => {
      const qualifiedFunds = `Because you indicated that you will use qualified funds to fund your application${this.hasMultipleProducts() ? 's':''}, you will be prompted to schedule a brief call after you submit online, so we can complete your application over the phone. Your rate will not be locked in until the application process is complete. Applications are subject to review and approval by Nassau.`;
      const qualifiedFundsRecommend = `Because you indicated that you will use qualified funds to fund your application${this.hasMultipleProducts() ? 's':''}, your producer will contact you to complete your application over the phone. Your rate will not be locked in until the application process is complete. Applications are subject to review and approval by Nassau.`;
      const defaultText = `Your application${this.hasMultipleProducts() ? 's are' : ' is'} ready to submit. Your rate will not be locked in until the application process is complete. Applications are subject to review and approval by Nassau.`;

      // 2022.06.20.ADivelbiss - No longer need to have separate messaging for FL.
      // if (isFL() || hasOwnerInFlorida()) {
      //   return (isRecommendation()) ? MYGAStrings.Finalize_SubmitText_FL_Recommended : MYGAStrings.Finalize_SubmitText_FL;
      // }
      if (hasJointOwner() || hasJointAnnuitant() || isCD()) {
        return (isRecommendation()) ? MYGAStrings.Finalize_SubmitText_JointOrCD_Recommended : MYGAStrings.Finalize_SubmitText_JointOrCD;
      }
      if (isUsingQualifiedFunds()) {
        return (isRecommendation()) ? qualifiedFundsRecommend : qualifiedFunds;
      }
      if (isReplacement()) {
        return (isRecommendation()) ? MYGAStrings.Finalize_SubmitText_Replacement_Recommended : MYGAStrings.Finalize_SubmitText_Replacement;
      }
      if (willStopPayments()) {
        return (isRecommendation()) ? MYGAStrings.Finalize_SubmitText_StopPayments_Recommended : MYGAStrings.Finalize_SubmitText_StopPayments;
      }
      return defaultText;
    }

    return (
      <Container className="page-section pb-0">
        <Row>
          <Col id="text-ready-to-submit">
            {getReadyText()}
          </Col>
        </Row>
      </Container>
    )
  }
  
  // renderRMDQuestion = () => {
  //   return isRMD() ? (
  //       <Container className="page-section pb-0">
  //         <form className={'needs-validation'}
  //               ref={(form) => {
  //                 this.pageForm = form;
  //               }}>
  //           <Row>
  //             <Col>
  //               <Question
  //                   containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
  //                   questionClass={'pb-2'}
  //                   responseClass={'pb-2 pl-2'}
  //                   data={this.state.submission}
  //                   question={PageManager.getQuestionByName('hasTakenRMDforCY')}
  //                   onChange={this.handleChange('submission')}/>
  //             </Col>
  //           </Row>
  //         </form>
  //       </Container>
  //   ) : (<></>);
  // }

  renderAgentInfo = () => {
    const renderNoAgent = (
      <RowCol>
        No Agent Information Provided
      </RowCol>
    )

    const renderAgent = () => (
      <>
        <RowCol>
          {
            isValid(this.agentInfo.name) ? this.agentInfo.name :
              `${this.agentInfo[AGENT_INFO_V01.firstName]} ${this.agentInfo[AGENT_INFO_V01.lastName]}`
          }
        </RowCol>
        <RowCol>
          {this.agentInfo.email}
        </RowCol>
        <RowCol>
          {
            isValid(this.agentInfo.phone) ? this.agentInfo.phone : this.agentInfo[AGENT_INFO_V01.mobile]
          }
        </RowCol>
      </>
    )

    return (
        <Container className="page-section">
          {this.renderSectionHeader('Agent Information: ', this.editButtonForPage(PAGES.pageAgentCode))}
          {this.agentInfo ? renderAgent() : renderNoAgent}
        </Container>
    )
  }

  renderParty = (party,index) => {
    return  (
        <div className={'pb-1'}>
          {
            this.renderSectionHeader(
                `${typeForParty(party)}: `,
                this.editButtonForPage(PAGES.pageAppIdOwnerAnnuitant,()=>{
                  mygaSession.setCurrentPartyIndex(index);
                })
            )
          }
          {/*{*/}
          {/* If party is a trust, then render the trust info, if not, then keep going  */}
          {/*}*/}
          {
            party[PARTY.entityType] ===  ENTITY_TYPE.trust ? (
                <RowCol>
                  {party[PARTY.trustName]}&nbsp;
                  <PopoverTooltip className="d-inline-block" icon={'ellipsis-h'} content={
                    <div>
                      <p><b>Address:</b><br/>{party[PARTY.addressStreet]}<br/>{`${party[PARTY.addressCity]}, ${party[PARTY.addressState]} ${party[PARTY.addressZip]}`}</p>
                      <p><b>Date of Trust:</b><br/>{party[PARTY.dateOfTrust]}</p>
                    </div>
                  }/>
                </RowCol>
            ) : (
                <RowCol>
              {party[PARTY.firstName] + " " +party[PARTY.lastName]}&nbsp;
              <PopoverTooltip className="d-inline-block" icon={'ellipsis-h'} content={
                <div>
                  <p><b>Address:</b><br/>{party[PARTY.addressStreet]}<br/>{`${party[PARTY.addressCity]}, ${party[PARTY.addressState]} ${party[PARTY.addressZip]}`}</p>
                  <p><b>Date of Birth:</b><br/>{party[PARTY.dob]}</p>
                  <p><b>SSN or TaxID:</b><br/>{party[PARTY.ssnOrTaxId]}</p>
                  <p><b>Phone Number:</b><br/>{party[PARTY.daytimePhone]}</p>
                </div>
              }/>
            </RowCol>)
          }
        </div>
    )
  }
  
  renderPartiesInfo = (parties) => {
    return (
      <div className={'pb-3'}>
        {/*<RowCol>*/}
        {/*  <b>Applicant Information: </b>*/}
        {/*</RowCol>*/}
        {
          parties.map((party,index)=>{
            return this.renderParty(party,index);
          })
        }
      </div>
    );
  }
  
  renderBenesInfo = (benes) => {
    let primaryBenes =  benes.filter(bene => bene[BENEFICIARY.beneficiaryType] === BENEFICIARY_TYPE.primary);
    let contingentBenes =  benes.filter(bene => bene[BENEFICIARY.beneficiaryType] === BENEFICIARY_TYPE.contingent)
    return (
      <>
        {this.renderSectionHeader(`Primary Beneficiaries (${primaryBenes.length}): `, this.editButtonForPage(PAGES.pageAppBenes))}
        {
          primaryBenes
            .map((bene, index) => {
                // NassauLog(JSON.stringify(bene));
                return (
                  <Row key={index}>
                    <Col>
                      {nameOfBene(bene)}
                    </Col>
                    <Col>
                      {bene[BENEFICIARY.relationshipToOwner]}
                    </Col>
                    <Col>
                      {(bene.share || 0) + "%"}
                    </Col>
                  </Row>
                );
              }
            )}
        {
          contingentBenes.length>0 && (
              <>
                {this.renderSectionHeader(`Contingent Beneficiaries (${contingentBenes.length}): `, this.editButtonForPage(PAGES.pageAppBenes))}
                {
                  contingentBenes
                      .map((bene, index) => {
                            // NassauLog(JSON.stringify(bene));
                            return (
                                <Row key={index}>
                                  <Col>
                                    {nameOfBene(bene)}
                                  </Col>
                                  <Col>
                                    {bene[BENEFICIARY.relationshipToOwner]}
                                  </Col>
                                  <Col>
                                    {(bene.share || 0) + "%"}
                                  </Col>
                                </Row>
                            );
                          }
                      )}
              </>
            )
        }
      </>
    )
  }

  renderProductCard = (product, payments) => {
    if (product == null) return
    return (
    <div className={'pb-4'}>
      <ProductCardSimpleAnnuity product={product}
                                hideEditButton={true}
                                hidePayments={this.shouldHidePayments()}
                                payments={payments}
                                onEditPayments={()=>this.props.updatePage(PAGES.pageAppPayments,PAGES.pageAppFinalize)}/>
    </div>
    )
  }
  
  render() {
    const dividerStyle = () => this.state.cart.length>1 ? {borderTop: '1px gray solid'} : {};
    return (
      <AppContentWrapper
        validateOnNext={this.validate}
        onBackPressed={this.onBackPressed}
        onNextPressed={this.onNextPressed}
        updatePage={this.props.updatePage}
        errorMessage={this.state.errorMessage}>

        {this.renderReadyToSubmit()}
        
        {/*{this.renderRMDQuestion()}*/}
        {this.renderAgentInfo()}
  
        <Container className="page-section pt-0">
          {
            this.state.cart.map((product)=>{
              return (
                  <Row className={'pt-3'} style={{borderTop: '1px gray solid'}}>
                    <Col xs={12} lg={5} className="pl-0 pr-0">
                      {this.renderPartiesInfo(product[MM_PRODUCT.dto][MM_PRODUCT_DTO.parties])}
                      {this.renderBenesInfo(product[MM_PRODUCT.dto][MM_PRODUCT_DTO.benes])}
                    </Col>
      
                    {/*/!* Product Cards *!/*/}
                    <Col xs={12} lg={7} className={"pt-4 pt-lg-0 pl-0 pr-0"}>
                      {this.renderProductCard(product,product[MM_PRODUCT.dto][MM_PRODUCT_DTO.payments])}
                    </Col>
                  </Row>
              )
            })
          }
        </Container>
        
      </AppContentWrapper>
    );
  }
}

export default Finalize;